export const STEFOY_CONFIG = {
  baseUrl: "https://adventuregroup.api.climb-up-gestion.fr/city-aventure-saintefoy",

  paths: {
    gdprCustomer: "/gdpr-customer",

    gdprCandidate: "/gdpr-candidate",

    termsAndConditions: "/fr/conditions-generales-de-vente",

    signIn: "/fr/account/sign-in",

    signUp: "/fr/account/sign-up",

    account: "/fr/account/account",

    resetPassword: "/fr/account/reset-password",

    newPassword: "/fr/account/new-password",

    recruitmentPost: "/post",

    recruitmentPostList: "/posts",

    cartProduct: "/fr/cart/product",

    cartCustomer: "/fr/cart/customer",

    cartPayment: "/fr/cart/payment",

    useTicketsBookBarcode: "/bookings/find"
  }
};

export const ALBIGNY_CONFIG = {
  baseUrl: "https://adventuregroup.api.climb-up-gestion.fr/cityaventure-lyon-albigny",

  paths: {
    gdprCustomer: "/gdpr-customer",

    gdprCandidate: "/gdpr-candidate",

    termsAndConditions: "/fr/conditions-generales-de-vente",

    signIn: "/fr/account/sign-in",

    signUp: "/fr/account/sign-up",

    account: "/fr/account/account",

    resetPassword: "/fr/account/reset-password",

    newPassword: "/fr/account/new-password",

    recruitmentPost: "/post",

    recruitmentPostList: "/posts",

    cartProduct: "/fr/cart/product-albigny",

    cartCustomer: "/fr/cart/customer-albigny",

    cartPayment: "/fr/cart/payment-albigny",

    useTicketsBookBarcode: "/bookings/find"
  }
};
